module.exports = __webpack_public_path__ + "operace-usnich-boltcu_1_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/operace-usnich-boltcu_1_after_tn.jpg
// module id = 1679
// module chunks = 0